import React, { Component } from 'react';
import { Field } from 'formik';

const { gpaMaxes, satMaxes } = require('buyside/util/constantsFromRails.json');
import InputField from 'buyside/components/presentation/Form/Field/InputField/inputField';

import styles from './MaxSelectStyles';

class MaxSelect extends Component {
  render() {
    const { isMobile, scoreName, maxScoreName, maxScoreOptions } = this.props;

    return (
      <div className={`${isMobile ? '' : styles.container}`}>
        <Field component={InputField} type="number" name={scoreName} placeholder="Enter a number" />
        <div className={`${isMobile ? styles.responsiveText : styles.centerText}`}>out of</div>
        {maxScoreOptions.length && (
          <Field
            component={InputField}
            type="select"
            name={maxScoreName}
            options={maxScoreOptions}
          />
        )}
      </div>
    );
  }
}

export const ACTSelect = props => (
  <MaxSelect
    scoreName="minimum.act.score"
    maxScoreName="minimum.act.max"
    maxScoreOptions={[36]}
    {...props}
  />
);

export const GPASelect = props => (
  <MaxSelect
    scoreName="minimum.gpa.score"
    maxScoreName="minimum.gpa.max"
    maxScoreOptions={gpaMaxes}
    {...props}
  />
);

export const SATSelect = props => (
  <MaxSelect
    scoreName="minimum.sat.score"
    maxScoreName="minimum.sat.max"
    maxScoreOptions={satMaxes}
    {...props}
  />
);
